/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
import { push } from 'react-router-redux';
import { notification } from 'antd';
import { delay } from 'redux-saga';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { change } from 'redux-form';
import { flatten, flattenDeep, values, get, compact } from 'lodash';
import { searchElementMatch, setNotification, searchElementMatchWithoutLanguage, getLocalePropertyValue } from 'utils';
import * as ResellerActions from '../actions/resellerActions';
import * as ResellerApi from '../api/resellerApi';
import * as ResellerTypes from '../types/resellerTypes';
import { loadResellersLayoutSaga } from './layoutSaga';

const getSegment = state => state.segment;
const getReseller = state => state.reseller;
const getLayout = state => state.layout;
const getForm = state => state.form;

// L O A D   R E S E L L E R S
function* loadResellersSaga() {
    try {
        const reseller = yield select(getReseller);
        const { offset, limit, sort } = reseller;

        const filters = {};

        const params = {
            offset,
            limit,
        };

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'name') {
                params.sort_by = JSON.stringify({ name: sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        if (reseller.filters.name !== '') {
            filters.name = {
                operator: 'typing',
                name: reseller.filters.name,
            };
        }

        params.filter = JSON.stringify(filters);

        const result = yield ResellerApi.getResellersApi(params);
        if (result.status === 200) {
            yield put(ResellerActions.loadResellersRes(result.data));
        }
    } catch (e) {
        yield put(ResellerActions.loadResellersErr());
        console.log(e);
    }
}

export function* loadResellersWatcher() {
    yield takeLatest(ResellerTypes.LOAD_RESELLERS, loadResellersSaga);
}
// L O A D   R E S E L L E R S

function* addTemplateToReseller(data) {
    yield ResellerApi.addTemplateToResellerApi(data);
}

// A D D   N E W   R E S E L L E R
function* addNewResellerSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'reseller.notification.newResellerAddedSuccess';

    try {
        const data = {
            reseller_id: action.data.reseller_id,
        };
        const result = yield ResellerApi.addNewResellerApi(action.data);

        if (result.status === 202) {
            const formData = new FormData();

            yield put(ResellerActions.addNewResellerRes(true, false));


            if (action.data.invoiceTemplates && action.data.invoiceTemplates.length > 0) {
                const { invoiceTemplates } = action.data;

                const attachParams = { bulk: [] };

                for (let i = 0; i < invoiceTemplates.length; i += 1) {
                    attachParams.bulk.push({
                        reseller_id: data.reseller_id,
                        template: invoiceTemplates[i].template,
                        language: invoiceTemplates[i].language,
                        source: invoiceTemplates[i].source,
                    });
                }

                attachParams.bulk.forEach((value, key) => {
                    const valueKeys = Object.keys(value);

                    valueKeys.forEach((v) => {
                        if ((v === 'template') && (value[v] === null)) {
                            formData.append(`bulk[${key}][${v}]`, '');
                        } else if ((v === 'template') && (value[v].length === 0)) {
                            formData.append(`bulk[${key}][${v}]`, '');
                        } else if ((v === 'template') && (value[v][0].url)) {
                            formData.append(`bulk[${key}][${v}]`, value[v][0].url);
                        } else if ((v === 'template') && (value[v][0].url === null)) {
                            formData.append(`bulk[${key}][${v}]`, '');
                        } else if ((v === 'template') && (value[v][0].originFileObj)) {
                            formData.append(`bulk[${key}][${v}]`, value[v][0].originFileObj);
                        } else {
                            formData.append(`bulk[${key}][${v}]`, value[v]);
                        }
                    });
                });

                yield call(addTemplateToReseller, formData);
            }

            yield put(push('/settings/shops/'));

            yield put(ResellerActions.addNewResellerRes(false, true));
            yield delay(1000);
            yield put(ResellerActions.addNewResellerRes(false, false));
            yield delay(2000);
            yield call(loadResellersLayoutSaga, {});

            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(ResellerActions.addNewResellerErr(error.message));
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'reseller.notification.addingNewResellerError');
        yield put(ResellerActions.addNewResellerErr());
        console.log(e);
    }
}

export function* addResellerWatcher() {
    yield takeLatest(ResellerTypes.ADD_NEW_RESELLER, addNewResellerSaga);
}
// A D D   N E W   R E S E L L E R

// L O A D   E D I T A B L E   R E S E L L E R S
function* loadEditableResellerSaga(action) {
    try {
        const param = {
            filter: JSON.stringify({
                id: action.id,
            }),
        };

        const resultReseller = yield ResellerApi.getResellersApi(param);

        if (resultReseller.data.hits.length === 0) {
            notification.error({
                message: 'Error',
                description: 'Reseller does not exist',
            });

            yield put(push('/404'));
            yield put(ResellerActions.loadResellersErr());
        } else {
            yield put(ResellerActions.loadEditableResellerRes(resultReseller.data.hits[0]));
        }
    } catch (e) {
        yield put(ResellerActions.loadResellersErr());
        console.log(e);
    }
}

export function* loadEditableResellerWatcher() {
    yield takeLatest(ResellerTypes.LOAD_EDITABLE_RESELLER, loadEditableResellerSaga);
}
// L O A D   E D I T A B L E   R E S E L L E R S

// E D I T   R E S E L L E R S
function* editResellerSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    try {
        const data = {
            reseller_id: action.data.reseller_id,
        };

        const result = yield ResellerApi.editResellerApi(action.data);

        if (result.status === 202) {
            const formData = new FormData();

            if (action.data.invoiceTemplates && action.data.invoiceTemplates.length > 0) {
                const { invoiceTemplates } = action.data;

                const attachParams = { bulk: [] };

                for (let i = 0; i < invoiceTemplates.length; i += 1) {
                    attachParams.bulk.push({
                        reseller_id: data.reseller_id,
                        template: invoiceTemplates[i].template,
                        language: invoiceTemplates[i].language,
                        source: invoiceTemplates[i].source,
                    });
                }

                attachParams.bulk.forEach((value, key) => {
                    const valueKeys = Object.keys(value);

                    valueKeys.forEach((v) => {
                        if ((v === 'template') && (value[v] === null)) {
                            formData.append(`bulk[${key}][${v}]`, '');
                        } else if ((v === 'template') && (value[v].length === 0)) {
                            formData.append(`bulk[${key}][${v}]`, '');
                        } else if ((v === 'template') && (value[v][0].url)) {
                            formData.append(`bulk[${key}][${v}]`, value[v][0].url.replace(process.env.REACT_APP_CDN, ''));
                        } else if ((v === 'template') && (value[v][0].url === null)) {
                            formData.append(`bulk[${key}][${v}]`, '');
                        } else if ((v === 'template') && (value[v][0].originFileObj)) {
                            formData.append(`bulk[${key}][${v}]`, value[v][0].originFileObj);
                        } else {
                            formData.append(`bulk[${key}][${v}]`, value[v]);
                        }
                    });
                });

                yield call(addTemplateToReseller, formData);
            }

            yield put(push('/settings/shops/'));
            yield put(ResellerActions.editResellerRes(result));
            yield delay(1000);
            setNotification('success', locale, 'global.success', 'reseller.notification.resellerEditedSuccess');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(ResellerActions.editResellerErr(error.message));
        }
    } catch (e) {
        yield put(ResellerActions.editResellerErr());
        setNotification('error', locale, 'global.error', 'reseller.notification.resellerEditedError');
        console.log(e);
    }
}

export function* editReseller2Watcher() {
    yield takeLatest(ResellerTypes.EDIT_RESELLER, editResellerSaga);
}
// E D I T   R E S E L L E R S

// D E L E T E   I N V O I C E   T E M P L A T E
function* deleteInvoiceTemplateSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield ResellerApi.deleteTemplateToResellerApi(action.data);

        if (result.status === 202) {
            yield put(ResellerActions.deleteInvoiceTemplateRes(true));
            yield delay(1000);
            yield put(ResellerActions.deleteInvoiceTemplateRes(false));
            setNotification('success', locale, 'global.success', 'designLibrary.notification.deleteDesignLibrarySuccess');
        } else {
            yield put(ResellerActions.deleteInvoiceTemplateErr());
            setNotification('error', locale, 'global.error', 'designLibrary.notification.deleteDesignLibraryError');
        }
    } catch (e) {
        yield put(ResellerActions.deleteInvoiceTemplateErr());
        setNotification('error', locale, 'global.error', 'designLibrary.notification.deleteDesignLibraryError');
        console.log(e);
    }
}

export function* deleteInvoiceTemplateWatcher() {
    yield takeLatest(ResellerTypes.DELETE_INVOICE_TEMPLATE, deleteInvoiceTemplateSaga);
}
// D E L E T E   I N V O I C E   T E M P L A T E


// F I L T E R   R E S E L L E R S
function* setResellersFiltersSaga() {
    try {
        const reseller = yield select(getReseller);

        const { offset, limit } = reseller;

        const filters = {};

        if (reseller.filters.name !== '') {
            filters.name = {
                operator: 'typing',
                name: reseller.filters.name,
            };
        }

        if (reseller.filters.domain !== '') {
            filters.domain = {
                operator: 'typing',
                domain: reseller.filters.domain,
            };
        }

        if (reseller.filters.siteGroup !== '') {
            filters.site_group = {
                operator: 'typing',
                site_group: reseller.filters.siteGroup,
            };
        }

        let params = {
            offset,
            limit,
            filter: JSON.stringify(filters),
        };

        if (!reseller.filters.name && !reseller.filters.domain && !reseller.filters.siteGroup) {
            params = {
                offset,
                limit,
            };
        }

        if (reseller.sort !== null) {
            params.sort_by = JSON.stringify({ name: reseller.sort.type === 'asc' ? 1 : -1 });
        }

        const result = yield ResellerApi.getResellersApi(params);
        yield put(ResellerActions.setResellersFiltersRes(result.data));
        yield delay(500);
    } catch (e) {
        yield put(ResellerActions.loadResellersErr());
        console.log(e);
    }
}

export function* setResellersFilterWatcher() {
    yield takeLatest(ResellerTypes.SET_RESELLERS_FILTER, setResellersFiltersSaga);
}
// F I L T E R   R E S E L L E R S


// R E S E T   F I L T E R   R E S E L L E R S
function* resetFiltersResellerSaga() {
    try {
        const reseller = yield select(getReseller);
        const { offset, limit } = reseller;

        const params = {
            offset,
            limit,
        };

        const result = yield ResellerApi.getResellersApi(params);
        yield put(ResellerActions.resetFiltersResellersRes(result.data));
    } catch (e) {
        yield put(ResellerActions.loadResellersErr());
    }
}

export function* resetFiltersResellersWatcher() {
    yield takeLatest(ResellerTypes.RESET_FILTER_RESELLERS, resetFiltersResellerSaga);
}
// R E S E T   F I L T E R   R E S E L L E R S


// L O A D   R E S E L L E R   S E G M E N T S
function* loadResellerSegmentsSaga(action) {
    try {
        const params = {
            offset: 0,
            limit: 100,
            filter: JSON.stringify({
                // 'reseller_product.reseller_id': action.id,
                'resellers.reseller_id': action.id,
                // type: 'flat',
            }),
        };

        const result = yield ResellerApi.getSegmentsApi(params);
        yield put(ResellerActions.loadResellerSegmentsRes(result.data));
    } catch (e) {
        yield put(ResellerActions.loadResellerSegmentsErr());
        console.log(e);
    }
}

export function* loadResellerSegmentsWatcher() {
    yield takeLatest(ResellerTypes.LOAD_RESELLER_SEGMENTS, loadResellerSegmentsSaga);
}
// L O A D   R E S E L L E R   S E G M E N T S

// L O A D   S E G M E N T S   F O R   R E S E L L E R S
function* loadSegmentsForResellersSaga(action) {
    try {
        const segment = yield select(getSegment);
        const layout = yield select(getLayout);

        const { offset, limit } = segment;
        const { locale } = layout;
        const paramsFilter = { type: 'flat' };
        const params = {
            offset,
            limit,
        };

        if (!action.parentId) {
            paramsFilter.title = searchElementMatch(action.value, locale);
        } else {
            paramsFilter.parent = action.parentId;
        }

        params.filter = JSON.stringify(paramsFilter);
        const result = yield ResellerApi.getSegmentsApi(params);
        yield put(ResellerActions.loadSegmentsForResellersRes(result.data));
    } catch (e) {
        yield put(ResellerActions.loadSegmentsForResellersErr());
        console.log(e);
    }
}

export function* loadSegmentsForResellersWatcher() {
    yield takeLatest(ResellerTypes.LOAD_SEGMENTS_FOR_RESELLERS, loadSegmentsForResellersSaga);
}
// L O A D  S E G M E N T S   F O R   R E S E L L E R S

// L O A D   P R O D U C T  G R O U P S
function* loadProductGroupsForResellersSaga() {
    try {
        const reseller = yield select(getReseller);
        const { listingProductGroupsForResellers } = reseller;

        const { offset, limit } = listingProductGroupsForResellers;

        const params = {
            offset,
            limit,
        };

        if (listingProductGroupsForResellers.filters.name !== '') {
            params.filter = JSON.stringify({
                name: searchElementMatchWithoutLanguage(listingProductGroupsForResellers.filters.name),
            });
        }

        const result = yield ResellerApi.getProductGroupsApi(params);
        yield put(ResellerActions.loadProductGroupsForResellersRes(result.data));
    } catch (e) {
        yield put(ResellerActions.loadProductGroupsForResellersErr());
        console.log(e);
    }
}

export function* loadProductGroupsForResellersWatcher() {
    yield takeLatest(ResellerTypes.LOAD_PRODUCT_GROUPS_FOR_RESELLERS, loadProductGroupsForResellersSaga);
}
// L O A D   P R O D U C T  G R O U P S

// L O A D   L I N K E D   R E S E L L E R   P R O D U C T  G R O U P S
function* loadLinkedResellerProductGroupsSaga(action) {
    try {
        const paramsSegment = {
            offset: 0,
            limit: 100,
            filter: JSON.stringify({
                _id: action.id,
            }),
        };

        const resultSegment = yield ResellerApi.getSegmentsApi(paramsSegment);
        if (resultSegment.status === 200) {
            if (resultSegment.data.hits.length > 0) {
                const productsArray = [];
                const getSegmentProducts = resultSegment.data.hits[0].reseller_product.filter(segment => segment.reseller_id === action.reseller);
                getSegmentProducts.forEach((segment) => {
                    productsArray.push(segment.product_group_id);
                });
                const paramsProducts = {
                    offset: 0,
                    limit: 100,
                    filter: JSON.stringify({
                        _id: productsArray,
                    }),
                };
                const resultProducts = yield ResellerApi.getProductGroupsApi(paramsProducts);
                if (resultProducts.status === 200) {
                    const orderedProducts = [];
                    if (resultProducts.data.hits.length > 0) {
                        getSegmentProducts.forEach((productSegment) => {
                            resultProducts.data.hits.forEach((productData) => {
                                if (productSegment.product_group_id === productData.id) {
                                    productData.product_order = productSegment.product_order;
                                    orderedProducts.push(productData);
                                }
                            });
                        });
                    }

                    yield put(ResellerActions.loadSegmentProductGroupsForResellersRes(orderedProducts));
                }
            }
        }
    } catch (e) {
        yield put(ResellerActions.loadSegmentProductGroupsForResellersErr());
        console.log(e);
    }
}

export function* loadLinkedResellerProductGroupsWatcher() {
    yield takeLatest(ResellerTypes.LOAD_EDITABLE_SEGMENT_PRODUCT_GROUP_FOR_RESELLERS, loadLinkedResellerProductGroupsSaga);
}
// L O A D   L I N K E D   R E S E L L E R   P R O D U C T  G R O U P S

// A D D   S E G M E N T   &   P R O D U C T   G R O U P
function* addSegmentProductGroupSaga(action) {
    const layout = yield select(getLayout);
    const form = yield select(getForm);
    const reseller = yield select(getReseller);

    const { locale } = layout;
    const { segments } = reseller;
    const { resellerForm, productGroupForm } = form;

    const recursiveTouch = list => list.map((item) => {
        if (segments.activeSegment.id === item.id) {
            return {
                ...item,
                new: false,
            };
        }

        return {
            ...item,
            children: recursiveTouch(item.children),
        };
    });

    try {
        const updatedSegments = resellerForm.values ? resellerForm.values.orderedSegments : null;
        const updatedProducts = productGroupForm.values ? flatten(values(productGroupForm.values)) : [];
        const resellerSegments = segments.edit.data ? segments.edit.data.hits : null;
        const bulkItem = [];
        let isEmpty = false;

        if (resellerForm.values.orderedSegments.length === 0 && resellerSegments.length === 0) {
            isEmpty = true;
            setNotification('error', locale, 'global.error', 'reseller.notification.noSegmentAssigned');
            yield put(ResellerActions.addSegmentProductGroupRes(false, false));
        } else if (resellerForm.values.orderedSegments.length !== 0 && updatedProducts.length === 0) {
            isEmpty = true;
            setNotification('error', locale, 'global.error', 'reseller.notification.emptySegment');
            yield put(ResellerActions.addSegmentProductGroupRes(false, false));
        } else {
            const segmentUpdated = {
                segment_id: segments.activeSegment.id,
                reseller_product: [],
            };

            let segmentOrder = null;
            for (let i = 0; i < updatedSegments.length; i += 1) {
                if (updatedSegments[i].id === segments.activeSegment.id) {
                    segmentOrder = i;
                }
            }

            for (let i = 0; i < updatedProducts.length; i += 1) {
                segmentUpdated.reseller_product.push({
                    reseller_id: action.id,
                    product_group_id: updatedProducts[i].id,
                    segment_order: segmentOrder + 1,
                    product_order: i + 1,
                });
            }

            if (segmentUpdated.reseller_product.length === 0) {
                resellerForm.values.orderedSegments.forEach((segment) => {
                    if (segmentUpdated.segment_id === segment.id) {
                        setNotification('error', locale, 'global.error', 'reseller.notification.segmentIsEmpty', { segment: get(getLocalePropertyValue(segment.title, locale), 'value', '') });
                        isEmpty = true;
                    }
                });
            } else {
                bulkItem.push(segmentUpdated);
            }
        }

        if (isEmpty) {
            yield put(ResellerActions.addSegmentProductGroupRes(false, false));
        } else {
            const paramsAdd = { bulk: bulkItem };
            const resultAdd = yield ResellerApi.addSegmentProductGroupApi(paramsAdd);

            if (resultAdd.status === 202) {
                yield put(ResellerActions.addSegmentProductGroupRes(true, false));
                yield put(ResellerActions.addSegmentProductGroupRes(false, true));
                yield delay(500);
                yield put(ResellerActions.addSegmentProductGroupRes(false, false));

                yield put(change('resellerForm', 'segments', Array.from(recursiveTouch(resellerForm.values.segments))));
                yield put(change('resellerForm', 'orderedSegments', Array.from(recursiveTouch(resellerForm.values.orderedSegments))));

                setNotification('success', locale, 'global.success', 'reseller.notification.addingNewProductGroupSuccess');
            } else {
                const error = yield resultAdd.json();
                setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
                yield put(ResellerActions.addSegmentProductGroupErr(error.message));
            }
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'reseller.notification.addingNewProductGroupError');
        yield put(ResellerActions.addSegmentProductGroupErr());
        console.log(e);
    }
}

export function* addSegmentProductGroupWatcher() {
    yield takeLatest(ResellerTypes.ADD_SEGMENT_PRODUCT_GROUP, addSegmentProductGroupSaga);
}
// A D D   S E G M E N T   &   P R O D U C T   G R O U P

// D E L E T E   S E G M E N T   P R O D U C T   G R O U P
function* deleteSegmentProductGroupSaga(action) {
    try {
        const layout = yield select(getLayout);
        const { locale } = layout;

        const bulkItemDelete = [{
            segment_id: action.segmentId,
            reseller_id: action.resellerId,
        }];
        const paramsDelete = { bulk: bulkItemDelete };
        const resultDelete = yield ResellerApi.deleteAllSegmentProductGroupApi(paramsDelete);

        if (resultDelete && resultDelete.status === 202) {
            yield put(ResellerActions.deleteSegmentProductGroupRes(true, false));
            yield put(ResellerActions.deleteSegmentProductGroupRes(false, true));
            yield delay(1000);
            yield put(ResellerActions.deleteSegmentProductGroupRes(false, false));
            setNotification('success', locale, 'global.success', 'reseller.notification.updateProductGroupsSuccess');
        } else {
            yield put(ResellerActions.deleteSegmentProductGroupRes(false, false));
            setNotification('error', locale, 'global.error', 'reseller.notification.deleteSegmentFromResellerError');
        }
    } catch (e) {
        yield put(ResellerActions.deleteSegmentProductGroupErr());
        console.log(e);
    }
}

export function* deleteSegmentProductGroupWatcher() {
    yield takeLatest(ResellerTypes.DELETE_SEGMENT_PRODUCT_GROUP, deleteSegmentProductGroupSaga);
}
// D E L E T E   S E G M E N T   P R O D U C T   G R O U P

// L O A D   E D I T A B L E   S E G M E N T   &   P R O D U C T   G R O U P   F O R   R E S E L L E R S
function* loadEditableSegmentForResellersSaga(action) {
    try {
        const params = {
            offset: 0,
            limit: 100,
            filter: {
                // 'reseller_product.reseller_id': action.id,
                'resellers.reseller_id': action.id,
                type: 'flat',
            },
        };

        if (action.parentId) {
            params.filter.parent = action.parentId;
        }

        params.filter = JSON.stringify(params.filter);

        const result = yield ResellerApi.getSegmentsApi(params);

        if (result.status === 200) {
            result.data.hits.sort((item1, item2) => item1.resellers.find(elem => elem.reseller_id === action.id).order - item2.resellers.find(elem => elem.reseller_id === action.id).order);

            yield put(ResellerActions.loadEditableSegmentForResellersRes(result.data));
        }
    } catch (e) {
        yield put(ResellerActions.loadEditableSegmentForResellersErr());
        console.log(e);
    }
}

export function* loadEditableSegmentForResellersWatcher() {
    yield takeLatest(ResellerTypes.LOAD_EDITABLE_SEGMENT_FOR_RESELLERS, loadEditableSegmentForResellersSaga);
}
// L O A D   E D I T A B L E   S E G M E N T   &   P R O D U C T   G R O U P   F O R   R E S E L L E R S

// C H A N G E   R E S E L L E R   S E G M E N T   O R D E R
function* changeResellerSegmentOrderSaga(action) {
    const { locale } = yield select(getLayout);
    const form = yield select(getForm);

    try {
        const { orderedSegments } = form.resellerForm.values;
        const bulkOrder = [];
        const newAttachments = [];

        const recursiveOrder = (list) => {
            for (let i = 0; i < list.length; i += 1) {
                const item = list[i];

                if (item.new) {
                    newAttachments.push({
                        segment_id: item.id,
                        reseller_id: action.resellerId,
                        segment_order: i + 1,
                    });
                }

                if (item.children?.length > 0) {
                    bulkOrder.push(recursiveOrder(item.children));
                }

                bulkOrder.push({
                    segment_id: item.id,
                    reseller_id: action.resellerId,
                    segment_order: i + 1,
                });
            }
        };
        recursiveOrder(orderedSegments);

        if (orderedSegments.length === 0) {
            setNotification('error', locale, 'global.error', 'reseller.form.segments.error.addSegments');
            yield put(ResellerActions.changeResellerSegmentOrderErr());
        } else {
            if (newAttachments.length > 0) {
                yield ResellerApi.attachResellerSegmentApi({
                    bulk: compact(flattenDeep(newAttachments)),
                });
            }

            const params = { bulk: compact(flattenDeep(bulkOrder)) };

            const result = yield ResellerApi.orderResellerSegmentsApi(params);
            if (result.status === 202) {
                setNotification('success', locale, 'global.success', 'reseller.form.segments.success.order');

                yield put(ResellerActions.changeResellerSegmentOrderRes(false, true));
                yield delay(500);
                yield put(ResellerActions.changeResellerSegmentOrderRes(false, false));
            }
        }
    } catch (e) {
        yield put(ResellerActions.changeResellerSegmentOrderErr());
        console.log(e);
    }
}

export function* changeResellerSegmentOrderWatcher() {
    yield takeLatest(ResellerTypes.CHANGE_RESELLER_SEGMENT_ORDER, changeResellerSegmentOrderSaga);
}
// C H A N G E   R E S E L L E R   S E G M E N T   O R D E R
